import { useState } from 'react'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '@/common/ui/dialog'
import { Button } from '@/common/ui/button'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import { BrokeNotificationQueryKeys } from '@/modules/client-setting/keys'
import { CreateBrokeNotificationRequest } from '@/modules/client-setting/type'
import useMutationCreateBrokeNotification from '@/modules/client-setting/api/hooks/useMutationCreateBrokeNotification'
import { Plus } from 'lucide-react'
import BrokeNotificationForm, {
	BrokeNotificationFormValues,
} from '../BrokeNotificationForm'

export default function CreateBrokeNotificationModal() {
	const [open, setOpen] = useState(false)
	const { mutate: createBrokeNotification } =
		useMutationCreateBrokeNotification()
	const queryClient = useQueryClient()

	const onSubmit = (formData: BrokeNotificationFormValues) => {
		createBrokeNotification(
			{
				payload: formData as unknown as CreateBrokeNotificationRequest,
			},
			{
				onSuccess: () => {
					toast.success('สร้างประกาศสำเร็จ')
					setOpen(false)
					queryClient.invalidateQueries({
						queryKey: [BrokeNotificationQueryKeys.GetBrokeNotifications],
					})
				},
				onError: (error) => {
					showErrorToast(error)
				},
			},
		)
	}

	return (
		<Dialog open={open} onOpenChange={setOpen}>
			<DialogTrigger asChild>
				<Button>
					<Plus className="mr-2 size-4" />
					เพิ่มประกาศ
				</Button>
			</DialogTrigger>
			<DialogContent className="sm:max-w-[800px]">
				<DialogHeader>
					<DialogTitle>เพิ่มประกาศเมื่อผู้เล่นเงินหมด</DialogTitle>
				</DialogHeader>
				<BrokeNotificationForm onSubmit={onSubmit} submitButtonText="สร้าง" />
			</DialogContent>
		</Dialog>
	)
}
